import RequestError from '@/errors/RequestError';
import { getCurrentDefaultValuesUrl } from '@/config/defaultValues';

export class PostprocessingTemplatesApi {
  static async getDefaultValues() {
    const url = getCurrentDefaultValuesUrl('postprocessingTemplate');
    const response = await fetch(url, {
      method: 'get',
      headers: {
        'Content-Type': 'text/plain',
      },
    });

    if (response.ok) {
      return response.json();
    }

    throw new RequestError();
  }
}
